import { OfficialDispatchToken } from "./OfficialDispatchToken";
import { OfficialDispatchImpl } from "../data/OfficialDispatchImpl";
import { IOfficialDispatchRepository } from "../domain/repositories/IOfficialDispatchRepository";
import { OfficialDispatchUseCase } from "../domain/useCases/OfficialDispatchUseCase";
import { DependenciesInjection } from "app/di/DependencyInjection";
import { OfficialDispatchViewModel } from "../presentation/viewModel/OfficialDispatchViewModel";

export class OfficialDispatchInjection {
  static initInjections() {
    DependenciesInjection.register<IOfficialDispatchRepository>(
      OfficialDispatchToken.IOfficialDispatchRepository,
      OfficialDispatchImpl,
      "otherRepo",
    );
    DependenciesInjection.register<OfficialDispatchUseCase>(
      OfficialDispatchToken.OfficialDispatchUseCase,
      OfficialDispatchUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<OfficialDispatchViewModel>(
      OfficialDispatchToken.OfficialDispatchViewModel,
      OfficialDispatchViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IOfficialDispatchRepository>(
      OfficialDispatchToken.IOfficialDispatchRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<OfficialDispatchUseCase>(
      OfficialDispatchToken.OfficialDispatchUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<OfficialDispatchViewModel>(
      OfficialDispatchToken.OfficialDispatchViewModel,
    );
  }
}
